(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./group',
            './Trace',
            './levels',
            './console'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('./group'),
            require('./Trace'),
            require('./levels'),
            require('./console'));
    } else {
        root.LogMessage = factory(root.group,
            root.Trace,
            root.levels,
            root.konsole);
    }
})(this, function (group, Trace, levels, konsole) {
    'use strict';
    var SEP 			= String.fromCharCode(9790);
    var SEP2			= String.fromCharCode(9789);
    var FMT_OBJECT 		= '%o, ';
    var FMT_STRING		= '%s ';
    var FMT_NAMESPACE 	= FMT_STRING + ':: ';
    var FMT_TRACE 		= FMT_OBJECT;
    var TRACE 			= SEP + 'trace' + SEP2;
    var ERROR 			= 'error';
    var GLOBAL 			= 'global';

    var	slice = Array.prototype.slice;
    var logHelper = Function.prototype.apply;
	/**
	 * LogMessage constructor.  Builds a basic messaging object
	 * that eases log message building and formatting.
	 * @param {string} level    Log level designation (@see levels).
	 * @param {mixed}  messages Any number of passed in values to be logged.
	 *                          the first messages is isolated to attempt to
	 *                          assign a namespace.
	 * @see  logger
	 */
    function LogMessage (instance) {
        this.ctx = instance;
    }

    LogMessage.prototype = {
        fmt: '%o',
        ns: null,
        format: function (type, messages) {
            var fmt = this.fmt;
            var ns;
            messages = slice.call(messages);
            if (!konsole.trueConsole) {
                return messages;
            }

            if (messages.length > 1 && !this.ctx.ns) {
                ns = messages.shift();
            } else {
                ns = this.ctx.ns || null;
            }

            if (this.ctx.useAlert) {
                if (ns) { messages.unshift(ns + ':: '); }
                return;
            }
            fmt = (new Array(messages.length)).join('\n' + FMT_OBJECT) + fmt;

            if (type === ERROR) {
                this.formatStack(ns, messages);
                fmt = FMT_OBJECT + fmt;
                type = 'error';
                messages.unshift(TRACE);
            }

            if (this.ctx.grouping) {
                group.start(ns);
            } else if (ns != null) {
                group.end(ns);
                fmt = fmt && typeof ns === 'string' ? FMT_NAMESPACE + fmt : null;
                messages.unshift(ns);
            }
            if (fmt) {
                messages.unshift(fmt);
            }
            return messages;
        },

        formatStack: function (ns, messages) {
            var i = 0;
            var len = messages.length;
            for (; i < len; i++) {
                if (messages[i] instanceof Error) {
                    messages[i] = new Trace(ns, messages[i]);
                }
            }
        },
        log: function (level, messages) {
            if (this.checkTypeAndLevel(level)) {
                logHelper.call(konsole[level] || konsole.log, konsole, this.format(level, messages));
            }
        },
        time: function (level, message) {
            if (this.checkTypeAndLevel(level)) {
                konsole.time(message);
            }
        },
        timeEnd: function (level, message) {
            if (this.checkTypeAndLevel(level)) {
                konsole.timeEnd(message);
            }
        },
        trace: function (level) {
            if (this.checkTypeAndLevel(level)) { konsole.trace(); }
        },
        checkTypeAndLevel: function (level) {
            var instance = this.ctx;
            var instanceLevel = levels[instance.level] ? instance.level : GLOBAL;

            if (instanceLevel === GLOBAL) {
                instanceLevel = instance.globalConsole && instance.globalConsole.level || 'none';
            }
            return levels[level] >= levels[instanceLevel];
        }
    };

    return LogMessage;
});
